const GET_INT_POSTID = (_q) => {
  for (let i = 0; i < _q.length; i++) {
    const Q = _q[i]
    if (Q.checked) return Q.value
  }
  return 0
}

const GET_STRING_POSTID = (_q) => {
  for (let i = 0; i < _q.length; i++) {
    const Q = _q[i]
    if (Q.checked) return Q.value
  }
  return ''
}

const GET_ARRAY_POSTID = (_q, _isNotPossible = false) => {
  const arr:Array<string|number> = []
  for (let i = 0; i < _q.length; i++) {
    const Q = _q[i]
    if (Q.checked) arr.push(Q.value)
  }
  if (_isNotPossible && arr.length === 0) arr.push(0)
  return arr
}

export const GET_NEEDS_B_ID = (_q) => {
  const ID = GET_ARRAY_POSTID(_q.q12_b.questions, true)
  return ID
}

export const GET_NEEDS_A_ID = (_q) => {
  const ID = GET_ARRAY_POSTID(_q.q12_a.questions, true)
  return ID
}

export const GET_PRICE_PERFORMANCE_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q11.questions)
  return ID
}

export const GET_TIRE_RIM_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q9.questions3)
  return ID
}

export const GET_TIRE_FLATNESS_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q9.questions2)
  return ID
}

export const GET_TIRE_WIDTH_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q9.questions)
  return ID
}

export const GET_BODY_TYPE_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q7.questions)
  return ID
}

export const GET_PASSENGER_ID = (_q) => {
  const ID = GET_ARRAY_POSTID(_q.q6.questions, true)
  return ID
}

export const GET_NUMBER_PEOPLE_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q5.questions)
  return ID
}

export const GET_AGE_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q4.questions)
  return ID
}

export const GET_GENDER_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q3.questions)
  return ID
}

export const GET_USE_ID = (_q) => {
  const ID = GET_ARRAY_POSTID(_q.q2.questions)
  return ID
}

export const GET_FREQUENCY_ID = (_q) => {
  const ID = GET_STRING_POSTID(_q.q1.questions)
  return ID
}

export const GET_MAKER_ID = (_q) => {
  const ID = GET_INT_POSTID(_q.obj_vehicle_type.questions)
  return ID
}

export const GET_CAR_MODEL_ID = (_q) => {
  const ID = GET_INT_POSTID(_q.obj_vehicle_type.questions2)
  return ID
}
